module.exports = __webpack_public_path__ + "static/media/logo-word.301026d9.svg";